import { styled as styledMui5 } from '@mui/material/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const StyledFontAwesomeIconMui5 = styledMui5(FontAwesomeIcon, {
  skipSx: false,
})(
  ({ theme, color }) => `
    color: ${theme.palette[color]?.main || color};`,
);
